// extracted by mini-css-extract-plugin
export default {"track":"MarginSlider_track__h5rOz","thumb":"MarginSlider_thumb__XEoKS","disabledThumb":"MarginSlider_disabledThumb__3qs-i","activeThumb":"MarginSlider_activeThumb__DjyEH"};